// extracted by mini-css-extract-plugin
export default {"modal":"bestek-list_modal__dlRKc","modal_header":"bestek-list_modal_header__6V-rX","download_button":"bestek-list_download_button__U5bRb"};